<template>
  <div class="content">
    <div class="wrapper">
      <div class="filters">
        <evaluationFilter ref="evaluationFilter" :filters="filters" :type="'multi'" :date="dateConfig" @getFilters="getFilters" />
        <div class="btn greenBtn srBtn" @click="startSearch">
          <img src="@assets/img/common/static.svg" alt="static">
          统计搜索
        </div>
        <div class="borderBottom"></div>
      </div>
      <div class="list">
        <div class="handles">
          <div class="btn" @click="getList">
            <img src="@assets/img/resources/fresh.svg" alt="fresh">
            刷新
          </div>
          <div class="btn greenBtn ml10" @click="exportRes">
            <img src="@assets/img/resources/export.svg" alt="export">
            导出
          </div>
        </div>
        <div class="titleLine">
          <span class="title">报道名称</span>
          <span class="name">供片</span>
          <span class="name">发布者</span>
          <span class="score">发布日期</span>
          <span class="score">考评日期</span>
          <span class="res">得分</span>
        </div>
        <empty :mTop="50" v-if="list.length === 0" :msg="'暂无统计数据'" />
        <div v-for="(l, i) in list" :key="i">
          <div class="item">
            <span class="grayBg"></span>
            <div class="inner">
              <div :class="{title: true, ft16: true, sec: true}" @click="goReport(l.report_id)">
                <span>{{l.report_title}}</span>
              </div>
              <div class="name sec">{{l.depart_title}}</div>
              <div class="name sec">{{l.user_name}}</div>
              <div class="score sec timeFont">{{l.report_release_time}}</div>
              <div class="score sec timeFont">{{l.raw_update_time}}</div>
              <div class="res sec">
                <div class="resItem" v-for="(r, d) in l.result" :key="d">
                  <div class="name">{{r.type}}</div>
                  <div class="score">{{r.name}}</div>
                  <div class="name gradeFont">{{r.app_res}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <pages :page_count="page.page_count" :index="page.pageIndex" :total="page.total"></pages>
      </div>
    </div>
  </div>
</template>

<script>
import evaluationFilter from '@components/evaluationFilter';
import common from '@common/common';
import pages from '@components/pages';
import { apis } from '@common/config';
import empty from '@components/empty';

export default {
  name: 'personStatic',
  components: {
    evaluationFilter, pages, empty
  },
  data() {
    return {
      isXnew: this.$store.state.isXnew,
      filters: [],
      dateConfig: {
        title: '发布时间',
        type: 'date',
        range: true,
        placer: ' 开始时间 ～ 结束时间'
      },
      filterOptions: {},
      page: {
        pageSize: 20,
        pageIndex: 1,
        page_count: 0,
        total: 0
      },
      list: []
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    startSearch() {
      // 统计搜索
      this.getList()
    },
    getFilters(f) {
      // 接收filters
      this.page.pageIndex = 1
      this.filterOptions = f
    },
    getList() {
      const id = this.$route.params.id
      const info = {
        idstring: id,
        depart_id: '',
        score: '',
        level: '',
        start: '',
        end: '',
        page: this.page.pageIndex,
        pagesize: this.page.pageSize
      }

      Object.assign(info, this.filterOptions)

      common.myFetch(apis.personStatic, info)
        .then((data) => {
          if (data) {
            this.list = data.list
            this.generateFilters(data.params.list_search)
            this.$set(this.page, 'page_count', common.calculatePage(data.page.row_count - 0, this.page.pageSize))
            this.$set(this.page, 'total', data.page.row_count - 0)
          }
        })
    },
    generateFilters(data) {
      // 整理过滤条件数据
      this.filters.forEach((i) => {
        data.forEach((j) => {
          if (i.key === j.key) {
            j.expand = !!i.expand
          }

          if (i.list) {
            i.list.forEach((c) => {
              j.list && j.list.forEach((d) => {
                if (c.key === d.key) {
                  d.expand = !!c.expand
                }
              })
            })
          }
        })
      })

      const filters = data.filter((i) => {
        return i.key !== 'start' && i.key !== 'end'
      })

      this.filters = filters
    },
    exportRes() {
      // 导出
      const info = {
        depart_id: '',
        score: '',
        level: '',
        start: '',
        end: ''
      }
      const userKeys = common.userKeys()
      const params = Object.assign({}, info, userKeys, this.filterOptions)
      const url = apis.personStaticExport

      common.exportRes(url, params)
    },
    getYesterday() {
      const today = +new Date()
      const yesterday = today - 24 * 60 * 60 * 1000

      return new Date(yesterday)
    },
    goReport(id) {
      // 跳转报道详情
      common.jump(`/reportDetail?d=${id}`, true)
    }
  }
}
</script>

<style lang="less" scoped src="@assets/css/evaluation/static.less"></style>